'use client';

import { useEffect, useRef, type RefObject } from 'react';

interface TileAnimationHandle {
    animateOneTile: () => void;
}

export function useInViewTileAnimation(animationRef: RefObject<TileAnimationHandle | null>) {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const hasAnimatedRef = useRef(false);

    useEffect(() => {
        const wrapper = wrapperRef.current;
        if (!wrapper || typeof IntersectionObserver === 'undefined') return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry?.isIntersecting && !hasAnimatedRef.current) {
                    animationRef.current?.animateOneTile();
                    hasAnimatedRef.current = true;
                }
            },
            { threshold: 0.5 },
        );
        observer.observe(wrapper);
        return () => observer.disconnect();
    }, [animationRef]);

    return wrapperRef;
}
